/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.businessList.internal

import features.businessList.models.Businesses
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class BusinessesServiceImpl : BusinessesService {

    private val businessesRequest = BusinessesRequest()

    override suspend fun getBusinesses(
        overrideHeaders : Map<String, String>?,
    ): Result<Businesses> {
        return businessesRequest.getBusinesses(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
